/**
 * Central color definitions for the application
 * These are referenced by the theme files and can be used directly
 * when theme context is not available
 */

export const primaryColors = {
  blue: {
    main: '#255ca5', // Raia blue
    light: '#3a74c4',
    lighter: '#6095dc',
    dark: '#1e4a85',
    darker: '#163966',
  },
  indigo: {
    main: '#6366f1',
    light: '#818cf8',
    lighter: '#a5b4fc',
    dark: '#4f46e5',
    darker: '#4338ca',
  },
  white: '#FFFFFF',
};

export const slateColors = {
  50: '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
};

export const semanticColors = {
  error: {
    light: 'rgba(244, 67, 54, 0.1)',
    main: '#f44336',
    dark: '#d32f2f',
  },
  success: {
    light: 'rgba(116, 198, 157, 0.1)',
    main: '#4caf50',
    dark: '#2e7d32',
  },
  warning: {
    light: '#fff3e0',
    main: '#ff9800',
    dark: '#ef6c00',
  },
  info: {
    light: '#e3f2fd',
    main: '#2196f3',
    dark: '#0d47a1',
  },
};

export const commonColors = {
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
};

export const overlayColors = {
  dark: {
    light: 'rgba(15, 23, 42, 0.7)',
    medium: 'rgba(15, 23, 42, 0.8)',
    heavy: 'rgba(15, 23, 42, 0.9)',
  },
  light: {
    light: 'rgba(255, 255, 255, 0.7)',
    medium: 'rgba(255, 255, 255, 0.8)',
    heavy: 'rgba(255, 255, 255, 0.9)',
  },
};
